"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Services_1 = require("../../../Services");
var Components_1 = require("../../../Components");
var DashboardNotifications = /** @class */ (function (_super) {
    __extends(DashboardNotifications, _super);
    function DashboardNotifications(props) {
        var _this = _super.call(this, props) || this;
        _this.notificationHandlerCallback = function () {
            _this.setState({ Notifications: _this.notificationToAlertComponent(Services_1.NotificationHandlerProvider.GetInstance().notifications) });
        };
        _this.notificationToAlertComponent = function (notifications) {
            var alertComponents = [];
            notifications.map(function (value) {
                alertComponents.push(React.createElement(Components_1.NotificationAlert, { key: value, callback: Services_1.NotificationHandlerProvider.GetInstance().DismissNotification, value: value }));
            });
            return alertComponents;
        };
        Services_1.NotificationHandlerProvider.Set(_this.notificationHandlerCallback);
        _this.state = { Notifications: _this.notificationToAlertComponent(Services_1.NotificationHandlerProvider.GetInstance().notifications) };
        return _this;
    }
    DashboardNotifications.prototype.render = function () {
        return React.createElement(React.Fragment, null, this.state.Notifications);
    };
    return DashboardNotifications;
}(React.Component));
exports.DashboardNotifications = DashboardNotifications;
//# sourceMappingURL=DashboardNotifications.js.map